import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { NotificationService, KeywordService, EnvService, MultiSubService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multiple-sub',
  templateUrl: './multiple-sub.component.html'
})
export class MultipleSubComponent implements OnInit {

  filterable = {
    from: null,
    to: null,
    country: null,
    operator: null,
    source: null,
    shortCode: null,
    currentIsActive: false,
  };
  loading = false;
  processing = false;
  totalItems = 0;
  emptyResult = true;
  multiSubReports = {};
  countryList: any = [];
  operatorList: any = [];
  sourceList = [];
  shortCodeList: any = [];

  exporting = false;
  active = 0;
  downloadUrl = '';

  allShortCodes = [];
  targetShortCode = null;


  constructor(
    private envSev: EnvService,
    private keywordSvc: KeywordService,
    private multiSubSvc: MultiSubService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadCountryAndOperator();
    this.loadAllShortCodes();
  }

  search() {
    this.totalItems = 0;
    this.loadPage();
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.multiSubSvc.export(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  onClear() {
    this.filterable.shortCode = null;
    this.targetShortCode = null;
  }

  gotoTargetShortCode(targetShortCode) {
    if (targetShortCode) {
      let country = this.countryList.find(it => { return it.code == targetShortCode.country });
      this.changeCountry(country, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.filterable.operator = null;
    this.filterable.shortCode = null;
    this.filterable.source = null;
    this.sourceList = [];
    this.shortCodeList = [];
    this.operatorList = country.operators;

    var targetOperator;
    if(targetShortCode){
      targetOperator = targetShortCode.operator;
    }else{
      targetOperator = this.operatorList[0];
    }
    this.changeOperator(targetOperator, targetShortCode);
  }

  changeOperator(operator, targetShortCode = null) {
    console.log("change operator: " + operator);

    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.sourceList = [];
    this.shortCodeList = [];
    this.filterable.source  = null;
    this.filterable.shortCode = null;
    if(operator){
        this.keywordSvc.getSelectionSourcesAndSc(this.filterable.country.code, this.filterable.operator).pipe(first()).subscribe((data) => {
          this.sourceList = data.data;
          if(targetShortCode){
            var targetSource = this.sourceList.find(it => {return it.value == targetShortCode.source});
            this.changeSource(targetSource, targetShortCode);
          }
        });
    }
  }

  changeSource(source, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.filterable.shortCode = null;
    if (source) {
      this.shortCodeList = source.subOptions;
      if(targetShortCode){
        this.changeShortCode(targetShortCode.shortCode, targetShortCode);
      }
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    if (!targetShortCode) {
      this.targetShortCode = this.allShortCodes.find(it => { return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator });
    }
  }

  private loadCountryAndOperator(){
    this.envSev.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;
      this.changeCountry(this.countryList[0]);
    });
  }

  private loadAllShortCodes() {
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if (data) {
        this.allShortCodes = data.data;
      }
    });
  }

  returnZero() {
    return 0;
  }

  private loadPage() {
    this.loading = true;
    this.emptyResult = false;
    this.multiSubReports = {};
    this.totalItems = 0;
    let params = this.formParam();
    // get page of items from api
    this.multiSubSvc.getAll(params).pipe(first()).subscribe(data => {

      if (data != null && data.status !== null && data.data) {
        this.loading = false;
        this.emptyResult = false;
        this.multiSubReports = data.data;
        this.totalItems = Object.keys(data.data).length;
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam() {
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      shortCode: this.filterable.shortCode,
      operator: this.filterable.operator,
      country: this.filterable.country.code,
      source: this.filterable.source == null ? "" : this.filterable.source.value,
      currentIsActive: this.filterable.currentIsActive,
    }
    return params;
  }

}
